export default "__VITE_ASSET__BJDwnvOV__"